export default {"src":"https://kroemtech.ch//_next/static/media/gear-check.9b034ea6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};